module.exports = __webpack_public_path__ + "1a39842066859d1bfd8d8be59bb4dd92.jpg";